<template>
  <div class="home">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <div class="container">
      <div>
        <div class="header">
          <div class="left"></div>
          <div class="right"></div>
        </div>
        <div class="intro">埃梯梯流体技术旗下的产品品牌历史悠久，传承着深厚的经验，汇聚着卓越的技艺，推动着持续的创新，为现代工业生产提供精准、高效、节能的解决方案，满足日新月异的市场需求和日益严格的市场规范。</div>
        <div class="sep">
          <div class="left"></div>
          <div class="right"></div>
        </div>
        <!-- <div class="logo">
          <img src="@/assets/spxflow_logo.png" alt="" />
        </div> -->
        <div class="brands-grid">
          <div class="brands-row" v-for="(brand, idx) in brands" :key="idx">
            <div class="brands-item" v-for="b in brand" :key="b.id">
              <a :href="'#/brands/' + b.id" v-if="b.blocks_count > 0">
                <span class="brands"
                  ><img :src="brandImg(b.id)" :alt="b.name"
                /></span>
              </a>
              <a v-else>
                <span class="brands"
                  ><img :src="brandImg(b.id)" :alt="b.name"
                /></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getBrands } from "@/api/request";

Object.defineProperty(Array.prototype, "chunk", {
  value: function (chunkSize) {
    var R = [];
    for (var i = 0; i < this.length; i += chunkSize) R.push(this.slice(i, i + chunkSize));
    return R;
  },
});

const idToImage = {
  1: "anhydro",
  2: "apv",
  4: "bran_luebbe",
  7: "gerstenberg_schroder",
  11: "johnson_pump",
  12: "lightnin",
  13: "plenty",
  18: "waukesha_cherry_burrell",
  19: "seital",
  22: "uutechnic",
  23: "stelzer",
  24: "philadelphia",
};

export default {
  name: "brands",
  data() {
    return {
      brands: [],
    };
  },
  methods: {
    brandImg(id) {
      return require("@/assets/brands/" + (idToImage[id] || id) + ".png");
    },
  },
  async mounted() {
    let brands = await getBrands();
    let order = [1, 2, 4, 7, 11, 12, 24, 13, 19, 23, 22, 18];
    let list = order.map((id) => brands.data.find((b) => b.id === id)).filter(Boolean);
    this.brands = list.chunk(2);
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  padding-bottom: 30px;
  min-height: calc(100vh - 221px);
  background-color: #eef0f7;
  .header {
    margin: 20px 10px;
    height: 15px;
    background-color: #407cca;
    display: flex;
    .left {
      flex: 1 0 62.4%;
    }
    .right {
      flex: 1 0 37.6%;
      background-color: #ccc;
    }
  }
  .intro {
    padding: 5px 15px;
    color: #535353;
  }
  .sep {
    margin: 10px 15px;
    box-sizing: border-box;
    height: 3px;
    background-color: #407cca;
    display: flex;
    .left {
      flex: 1 0 62.4%;
    }
    .right {
      flex: 1 0 37.6%;
      background-color: #ccc;
    }
  }
  .logo {
    text-align: center;
    padding: 20px 0;
    img {
      width: calc(100vw * (265 / 375));
    }
  }

  .brands-grid {
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    .brands-row {
      display: flex;
      .brands-item {
        flex: 0 0 50%;
        box-sizing: border-box;
        border-radius: 8px;
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding: 12px;
          box-sizing: border-box;
        }
      }
    }
  }
  .brands {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  // .brands-table {
  //   td {
  //     padding: 10px;
  //     a {
  //       display: block;
  //       border-bottom: 1px solid #999;
  //     }
  //   }
  // }
  // a {
  //   display: block;
  //   margin-top: 5px;
  //   .brands {
  //     span {
  //       color: #676667;
  //       font-weight: 700;
  //       padding-left: 10px;
  //       font-size: 13px;
  //       width: 100%;
  //       background: url(../assets/arrow_brand.jpg) no-repeat 0 7px;
  //       background-size: 10px auto;
  //     }
  //   }
  // }
}

// .footer {
//   border-bottom: 15px solid #686767;
//   position: relative;
//   bottom: 0;
//   .top {
//     height: 10px;
//     background: url(../assets/main/footer_bg.png) repeat-x;
//     background-size: 15%;
//   }
//   .content {
//     display: flex;
//     margin: 30px 12%;
//     .qr {
//       flex: 0 1 30%;
//       margin-right: 10px;
//       img {
//         width: 100px;
//       }
//     }
//     .info {
//       flex: 1 0 70%;
//       font-size: 10px;
//       text-align: left;
//       padding-left: 10px;
//       margin-top: 3px;
//       box-sizing: border-box;
//       h5 {
//         font-size: 11px;
//         color: #1d4f48;
//       }
//       p {
//         line-height: 20px;
//         margin-bottom: 0;
//       }
//     }
//   }
// }
</style>
